module.exports = __webpack_public_path__ + "img/gift7.45d11357.png";